module["exports"] = [
  "кв. ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/secondary_address.js
// module id = 1296
// module chunks = 0